import { Link } from "react-router-dom";
import cardimg1 from "../assest/images/cardimg1.png";
import cardimg2 from "../assest/images/cardimg2.png";
import cardimg3 from "../assest/images/cardimg3.png";
import cardimg4 from "../assest/images/cardimg4.png";
import cardimg5 from "../assest/images/cardimg5.png";
import cardimg6 from "../assest/images/cardimg6.png";
import cardimg7 from "../assest/images/cardimg7.png";
import cardimg8 from "../assest/images/cardimg8.png";
import helper, { getSlugByLang, getSlugNameByLang } from "../common/Helper";
import ListLoading from "./ListLoading";
import { useSelector } from "react-redux";

const TourStyle = ({ tourStyle, isTourStyleLoading, tourStyleNextPageUrl, onClickLoadMore, page = "OTHER", locationDetail = {} }) => {
    const images = [cardimg1, cardimg2, cardimg3, cardimg4, cardimg5, cardimg6, cardimg7, cardimg8];

    const user = useSelector((state) => state.user);
    const slugField = getSlugNameByLang(user?.language)
    const slugLang = getSlugByLang(user?.language)

    return (
        <section className="tourStyle">
            <div className="tourStylepart">
                <div className="container">
                    <div className="sectionTitle">
                        <h3>What is your tour style</h3>
                    </div>
                    <div className="tourBox">
                        <div className="row">
                            {
                                tourStyle?.length > 0 && tourStyle.map((ts, i) => {
                                    let img = (ts?.activity_theme?.listing_image ? ts?.activity_theme?.listing_image : ts?.listing_image) ?
                                        helper.S3Url + '/' + helper.productImageDir + '/' + (ts?.activity_theme?.listing_image ? ts?.activity_theme?.listing_image : ts?.listing_image) :
                                        (images[i] ? images[i] : images[0]);

                                    let lnk = (slugLang ? ('/' + slugLang) : '') + '/attraction/' + (ts?.activity_theme?.[slugField] ? ts?.activity_theme?.[slugField] : ts?.[slugField]) + (page == 'LOCATION' ? '?location=' + locationDetail?.[slugField] : '');

                                    return (
                                        <Link
                                            to={lnk}
                                            className="col-6 col-lg-3 col-md-4 col-sm-6" key={i} >

                                            <div className="tourGallery">
                                                <div className="imgBox">
                                                    <img src={img} alt={ts?.activity_theme?.name ? ts?.activity_theme?.name : ts?.name}
                                                        onError={(e) => {
                                                            e.target.onerror = null;
                                                            e.target.src = images[0]
                                                        }}
                                                    />
                                                    <div className="cardText">
                                                        <h5>{ts?.activity_theme?.name ? ts?.activity_theme?.name : ts?.name}</h5>
                                                        <p>{ts.linked_products_count} {ts.linked_products_count > 1 ? 'Tours' : 'Tour'}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </Link>
                                    )
                                })
                            }

                        </div>
                        {
                            isTourStyleLoading ? <ListLoading /> :
                                tourStyle.length > 0 && tourStyleNextPageUrl &&

                                <div className="showMore">
                                    <button className="btn showMoreBtn"
                                        onClick={() => onClickLoadMore('tourStyle', tourStyleNextPageUrl.split('=')[1])}
                                    >Show more <i className="fa-solid fa-chevron-right"></i></button>
                                </div>
                        }
                    </div>
                </div>
            </div>
        </section>
    )
}
export default TourStyle;